import AccountsAPI from '@api/AccountsAPI';

import { useAdvancedQuery } from '@hooks/QueryHooks';

import { getVendorRetailerPosDataQueryKey } from './BrandLinkQueries';

export const useVendorRetailerPosData = (
    vendorAccountId: string,
    retailerAccountId: string,
    isEnabled: boolean = true,
) => {
    const {
        isLoading: isLoadingVendorRetailerPosData,
        isFetched: vendorRetailerPosDataIsReady,
        refetch: refetchVendorRetailerPosData,
        data: vendorRetailerPosData,
        isRefetching: isRefetchingVendorRetailerPosData,
    } = useAdvancedQuery(
        getVendorRetailerPosDataQueryKey(vendorAccountId, retailerAccountId),
        () =>
            AccountsAPI.getVendorRetailerPosData({
                groupId: vendorAccountId,
                retailerAccountId,
            }),
        { enabled: isEnabled && !!vendorAccountId && !!retailerAccountId },
    );

    return {
        isLoadingVendorRetailerPosData,
        vendorRetailerPosDataIsReady,
        refetchVendorRetailerPosData,
        isRefetchingVendorRetailerPosData,
        vendorRetailerPosData,
    };
};
